//Roles from Keycloak
export const Transactions_Approve = "GG_Transactions_Approve";
export const Transactions_HardDelete = "GG_Transactions_HardDelete";
export const AuditLogs_Viewer = "GG_AuditLogs_Viewer";
export const GatewayLogs_Viewer = "GG_GatewayLogs_Viewer";
export const AdminWeb = "GG_AdminWeb";
export const HelpDeskOperator = "GG_HelpDeskOperator";
export const ManageProfile = "GG_ManageProfile";
export const ManageClients = "GG_SSO_Clients";
export const ManageServices = "GG_Manage_Services";
export const Claims_Viewer = "GG_Claims_Viewer";
export const Manage_TemplateClaims = "GG_Manage_Template_Claims";
export const ManageInstitutions = "GG_Manage_Institutions";
export const ManageRoles = "GG_Manage_Roles";

//Claim from Keycloak
export const ProfileType ="profiletype"

//Client scopes from Keycloak
export const UserDetails ="userdetails"
export const User_info ="user_info"
export const UserLike ="user"



